<template>
<div class="w-full mx-auto pb-32 pt-5 px-10">

  <div class="flex w-full">
    <div id="calendar" class="w-full">
      <div class="flex my-5 py-3 pl-2 text-2xl w-full justify-between">
        <h1>
          {{ $t('slotsCreation.calendarTitle').toUpperCase() }} </h1>
        <language-and-timezone></language-and-timezone>
      </div>

      <vue-cal
        :disable-views="['years', 'year']"
        today-button
        :time-from="timeFrom"
        :time-to="timeTo"
        :time-step="45"
        :events="events"
        class="bg-beige-academy-100 font-sans-serif"
        :on-event-dblclick="onEventClick"
        :editable-events="{
          title: false, drag: false, resize: false, delete: true, create: true }"
        :snap-to-time="15"
        :locale='$i18n.locale'
        :time-cell-height="60"
      />

    </div>

  </div>

  <modal resizable name="student-lesson" height="auto" :adaptive="true">
    <open-student-lesson
      :selectedEvent="selectedEvent"
      :selectedSlot="selectedSlot"
      :is-locked="selectedSlot.status === 'locked'" />
  </modal>
  <modal name="pending-lesson" :adaptive="true" :scrollable="true">
    <keep-alive>
      <component :is="componentToOpen" :notification="selectedNotification" />
    </keep-alive>
  </modal>

</div>
</template>

<script>
import axios from 'axios';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
import { mapGetters, mapActions } from 'vuex';
import AcceptNewLessonTime from '@/components/modals/AcceptNewLessonTime.vue';
import OpenStudentLesson from '../modals/OpenStudentLesson.vue';
import GlobeIcon from '../graphics/GlobeIcon.vue';
import LanguageAndTimezone from '../graphics/LanguageAndTimezone.vue';

export default {
  components: {
    OpenStudentLesson,
    GlobeIcon,
    AcceptNewLessonTime,
    LanguageAndTimezone,
  },
  data() {
    return {
      isLogged: true,
      events: [],
      ready: false,

      selectedEvent: '',
      start: '',
      timeFrom: 24 * 60,
      timeTo: 0 * 60,

      selectedSlot: {},

      componentToOpen: null,
      selectedNotification: null,
    };
  },

  computed: {
    ...mapGetters({
      beenUpdatedSlots: 'slots/updatedSlots',
      user: 'auth/user',
      dashboardPath: 'auth/dashboardPath',
      notifications: 'auth/notifications',
    }),
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  watch: {
    beenUpdatedSlots() {
      this.getSlots();
      this.updatedSlots(false);
    },

    choosenTimezone() {
      this.resetSlots();
    },
  },

  mounted() {
    this.getSlots();
  },

  methods: {
    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

    onEventClick(event, e) {
      e.stopPropagation();

      this.selectedEvent = event;

      if (event.class === 'past') {
        return;
      }

      if (event.class === 'masterclass') {
        this.openMasterclassView(event);
        return;
      }

      if (event.status === 'pending') {
        this.openPendingLesson(event);
        return;
      }

      this.$modal.show('student-lesson');
      this.getSelectedSlot();
    },

    resetSlots() {
      this.events = [];
      this.timeFrom = 24 * 60;
      this.timeTo = 0 * 60;
      this.getSlots();
    },

    getSlots() {
      this.ready = false;
      this.savedSlots = [];
      this.events = [];
      axios.get(`/api/students/${this.user.student.id}/slots`).then((response) => {
        this.createEventsForCalendar(response.data, this.events);
      }).catch((error) => {
        console.log(error);
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    createEventsForCalendar(slotsArrayToConvert, arrayToFill, isMasterclass) {
      slotsArrayToConvert.forEach((slot) => {
        this.savedSlots.push(slot);

        let returnArray = [];
        if (!isMasterclass) {
          returnArray = this.convertSlotForCalendar(slot, this.timeFrom, this.timeTo);
        } else {
          returnArray = this.convertMasterclassForCalendar(slot, this.timeFrom, this.timeTo);
        }

        const newEvent = returnArray.event;
        newEvent.status = slot.status;
        newEvent.title = slot.teacher.name;
        newEvent.booking_id = slot.booking_id;

        if (slot.pending_id) {
          newEvent.pending_id = slot.pending_id;
        }

        if (newEvent.class === 'pending') {
          newEvent.pending_id = slot.pending_id;
          newEvent.class = 'bg-white text-red-600';
          newEvent.title = '<i class="v-icon material-icons">hourglass_full</i>';
        }

        if (newEvent.class === 'locked') {
          newEvent.class = 'bg-white text-red-600';
          newEvent.title = `<i class="v-icon material-icons">error</i></br>${newEvent.title}`;
        }
        if (newEvent.class === 'booked') {
          newEvent.class = `bg-tiers-${slot.color} text-gray-100`;
          newEvent.content = `<i class="v-icon material-icons">${slot.icon}</i>`;
        }

        this.timeFrom = returnArray.timeFrom * 60;
        this.timeTo = returnArray.timeTo * 60;

        if (!arrayToFill.some((event) => event.start === newEvent.start)) {
          arrayToFill.push(newEvent);
        }
      });

      // this.setPendingSlotsBgColor();
    },

    getSelectedSlot() {
      axios.get(`/api/slots/${this.selectedEvent.id}`).then(({ data }) => {
        this.selectedSlot = data;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    openPendingLesson(lesson) {
      this.notifications.forEach((notification) => {
        const jsonObject = JSON.parse(notification.description);
        if (jsonObject && (jsonObject.id_old === lesson.id || jsonObject.id_new === lesson.id)) {
          this.componentToOpen = notification.component_to_open;
          this.selectedNotification = notification;
          this.$modal.show('pending-lesson');
        }
      });
    },
  },
};
</script>

<style lang="scss">
  .D1C4E9FF {
    background-color: #D1C4E9FF;
  }
</style>
